import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbService, BreadcrumbUrls} from '../../../providers/services/breadcrumb.service';
import {PathNames, Paths} from '../../../../config/config';
import {Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from '../../../providers/services/api.service';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss']
})
export class CookiesComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();

  public staticHtml;

  constructor(private breadcrumbService: BreadcrumbService, private apiService: ApiService) {
    this.breadcrumbService.next(
      BreadcrumbUrls.instance
        .addUrl({label: PathNames[Paths.Cookies], link: Paths.Cookies})
    );

    this.subscriptions.add(
      this.apiService.translateApi(lang => this.apiService.get(this.getEndpoint(lang)))
        .pipe(map(({body: {content}}) => content)).subscribe((resp) => {
        this.staticHtml = resp;
      })
    );
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.breadcrumbService.reset();
  }

  private getEndpoint(lang) {
    const ENDPOINT = (code) => `https://www.iubenda.com/api/privacy-policy/${code}/cookie-policy/no-markup`;
    switch (lang) {
      case 'de':
        return ENDPOINT(97390615);
      case 'es':
        return ENDPOINT(39496668);
      case 'fr':
        return ENDPOINT(65332241);
      case 'it':
        return ENDPOINT(18775813);
      case 'ru':
        return ENDPOINT(79255933);
      case 'pl':
        return ENDPOINT(37878374);
      default:
        return ENDPOINT(27988284);
    }
  }

}
